import GDPR from './GDPR';
import AdsModal from './AdsModal';

export function createElementFromHTML(htmlString) {
  let div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
}

export function initGDPR(storage) {
  let gbpr = new GDPR(storage)

  if (!gbpr.isAccepted()) {
    setTimeout(function () {
      gbpr.show();
    }, 1500)
  }
}

export function initClassParams(defaultParams, params) {
  return Object.assign(defaultParams, params);
}

export function initAdsModal(selector, config) {
  document.querySelectorAll(selector).forEach(x => {
    new AdsModal(x, { text: config.disclaimer_text });
  })
}



// WEBPACK FOOTER //
// ./scripts/libs/functions.js